export default __webpack_public_path__ + "static/appscreenshots_3-ca49d656a4af9381b866cb836f8e515c.png";